import { render, staticRenderFns } from "./showNum.vue?vue&type=template&id=5f0101f6&scoped=true&"
import script from "./showNum.vue?vue&type=script&lang=js&"
export * from "./showNum.vue?vue&type=script&lang=js&"
import style0 from "./showNum.vue?vue&type=style&index=0&id=5f0101f6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0101f6",
  null
  
)

export default component.exports